import { useCallback } from "react";
import { useOnboardingStore } from "../stores/StoreProvider";
import type { OnboardingData } from "../types";

export const useOnboarding = () => {
  const onboardingStore = useOnboardingStore();

  const complete = useCallback(
    (data: OnboardingData) => {
      onboardingStore.setOnboardingData(data);
    },
    [onboardingStore],
  );

  const skip = useCallback(() => {
    onboardingStore.skipOnboarding();
  }, [onboardingStore]);

  const reset = useCallback(() => {
    onboardingStore.resetOnboarding();
  }, [onboardingStore]);

  const setStep = useCallback(
    (step: number) => {
      onboardingStore.setCurrentStep(step);
    },
    [onboardingStore],
  );

  const nextStep = useCallback(() => {
    onboardingStore.nextStep();
  }, [onboardingStore]);

  const previousStep = useCallback(() => {
    onboardingStore.previousStep();
  }, [onboardingStore]);

  return {
    data: onboardingStore.data,
    isCompleted: onboardingStore.isCompleted,
    isSkipped: onboardingStore.isSkipped,
    currentStep: onboardingStore.currentStep,
    hasCompletedOnboarding: onboardingStore.hasCompletedOnboarding,
    profile: onboardingStore.onboardingProfile,
    bestStudyPeriod: onboardingStore.bestStudyPeriod,
    learningStyle: onboardingStore.learningStyle,
    studyPreference: onboardingStore.studyPreference,

    complete,
    skip,
    reset,
    setStep,
    nextStep,
    previousStep,
  };
};
